import { TextField } from "@material-ui/core";

import Base from "./Base";
import Checkbox from "./Checkbox";
import Date from "./Date";
import File from "./File";
import Number from "./Number";
import Select from "./Select";
import Textarea from "./Textarea";

export default function Field({ type = "text", ...props }) {
  return <Base as={TextField} type={type} {...props} />;
}

Field.Checkbox = Checkbox;
Field.Date = Date;
Field.File = File;
Field.Number = Number;
Field.Select = Select;
Field.Textarea = Textarea;
